<!--
 * @Description: 新闻资讯
 * @Author: pliybird
 * @Date: 2022-01-30 00:14:48
 * @LastEditTime: 2023-08-24 13:39:26
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
  <Layout>
    <div class="breadrumb">
      <div class="container">
        <div class="row">
          <nav style="--bs-breadcrumb-divider: '&gt;';" aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" style="font-size:16px;">
                <a href="javascript:;" @click="$router.go(-1)">
                  {{pageFlag === 'news'? $t("news.title"):$t("cases.title") }}
                </a>
              </li>
              <li class="breadcrumb-item active" style="font-size:16px;" aria-current="news-detail">{{pageFlag === 'news'? $t("news.detail"):$t("cases.detail") }}</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="news-detail rn-section-gap">
      <div class="container">
        <div class="row gx-5">
          <div class="col-lg-9 col-md-9  col-12 news-detail-left mt-4">
            <h1 v-if="pageFlag === 'news'" class="title">
              {{detail.title}}
            </h1>
            <h1 v-if="pageFlag === 'cases'" class="title">
              {{`${detail.name} | ${detail.solutionName}`}}
            </h1>
            <span v-if="pageFlag === 'news'" class="title1">{{ newsDate(detail.publishDate)}}</span>
            <Separator class="mb--30 mt--20" />
            <div v-html="detail.content"></div>
          </div>
          <div class="col-lg-3 col-md-3 col-12 news-detail-right mt-4 ">
            <div v-if="pageFlag === 'news'">
                <h2 class="title2">{{$t('news.hot_news')}}</h2>
                <!-- <div class="line"></div> -->
                <Separator class="mb--30 mt--20" />
                <router-link  v-for="(item,index) in newsList" :key="index" class="image" :to="{name:'NewsDetail',params:{lang:$i18n.locale,id:item.id,from:'news'}}">
                  <span class="d-block mt--10">{{item.title}}</span>
                </router-link>
                <div v-if="tagList.length">
                  <h2 class="title2 mt--20">{{$t('news.tags')}}</h2>
                  <Separator class="mb--20 mt--20" />
                  <ul class="news-label">
                    <li
                      class="label-name mr-3"
                      v-for="(item, index) in tagList"
                      :key="index"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
            </div>
            <div v-if="pageFlag === 'cases'">
              <div class="w-100 text-center mb--30">
                <img :src="baseUrl +'/'+ detail.logoUrl" alt="">
              </div>
              <dl >
                <dd class="d-flex"><strong class="w-25 mr--10">{{ $t("news.industry") }}</strong> <span class="flex-fill">{{detail.industry}}</span></dd>
                <dd class="d-flex"><strong class="w-25 mr--10">{{ $t("news.region") }} </strong><span class="flex-fill">{{detail.region}}</span></dd>
                <dd class="d-flex"><strong class="w-25 mr--10">{{ $t("news.product") }} </strong><span class="flex-fill">{{detail.usedProduct}}</span></dd>
              </dl>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../components/common/Layout";
import Separator from "../components/elements/separator/Separator";
import {casesDetail,newsDetail,newsList} from "@/helpers/api";
import moment from 'moment';
export default {
  name: "NewsDetail",
  components: { Layout, Separator },
  data() {
    return {
      baseUrl:process.env.VUE_APP_API_URL,
      detail:{},
      tagList:[],
      pageData:{},
      newsList:[],
      pageFlag:'',
    };
  },
  watch:{
    // 监听路由更新
    $route:{
      handler(val,oldval){
        this.pageData.id = val
       this.$router.go(0)
      }
    }
  },
  created(){
    const regex = /\/([^/]+)\/\d+$/;;
      const match = regex.exec(this.$route.path);
      if (match && match.length > 1) {
      this.pageFlag = match[1];
    }
    this.getDetail()
  },
  computed:{
    newsDate(){
      return date=>{
        return moment(date).format('YYYY-MM-DD')
      }
      
    }
  },
  beforeDestroy () {
    localStorage.removeItem('tempData')
  },
  methods: {
    getNewsList() {
        newsList(`lang=${this.$i18n.locale}&PageIndex=1&PageSize=3`).then((res) => {
          if (res.state == "success") {
            this.newsList = res.data.rows;
          }
        });
    },
    getDetail(){
      if(this.pageFlag == 'news'){
        this.getNewsList()
        newsDetail(`lang=${this.$i18n.locale}&id=${this.$route.params.id}`).then(res=>{
          if (res.state == "success") {
              this.detail = res.data
              if(res.data.tag){
                this.tagList = res.data.tag.split(',')
              }
            }
        })
      }else if(this.pageFlag == 'cases'){
        casesDetail(`lang=${this.$i18n.locale}&id=${this.$route.params.id}`).then(res=>{
          if (res.state == "success") {
              this.detail = res.data
          }
        })
      }
    }
  },
};
</script>

